import React, { useState } from 'react'

// Components
import { ValidationForm } from '../../../../../../_components/Forms/ValidationForm'
import { LoaderButton } from '../../../../../../_components/LoaderButton'
import { S_AddContactModal, S_Submit } from './styles'

// Services
import { businessService } from '../../../../../../_services'
import { createContact, updateContact } from '../../../../../../_services/debtor.service'
import { fetchFactoringBusinessSuggestions } from '../../../../../../_helpers/business'

// Hooks
import { useModal } from '../../../../../../_reduxHooks/modal.hook'
let syncronousClient = {}
/** FIXME:
 * This seems wrong, should it be named addContactModal instead?
 */
export const AddContactModal = ({
  callFromModal,
  clientId,
  closeModal,
  data,
  debtor,
  previousModalProps,
  readOnly,
  refresh,
  showNotification,
}) => {
  const { openModal } = useModal()
  let defaultEntity = {
    first_name: '',
    last_name: '',
    title: '',
    phone_number: '',
    fax_number: '',
    mobile_number: '',
    email: '',
    clients: [],
    notes: '',
  }
  let entity = clientId && data ? data : defaultEntity

  const [clientData, setClientData] = useState({ ...data })
  const [submitFn, setSubmitFn] = useState()
  const [isDisabled, setIsDisabled] = useState(false)

  const config = {
    entity: { ...entity },
    fields: [
      {
        type: 'text',
        id: 'first_name',
        layout: '',
        label: 'First Name',
        required: 'Required',
      },
      {
        type: 'text',
        id: 'last_name',
        layout: '',
        label: 'Last Name',
        required: false,
      },
      {
        type: 'text',
        id: 'title',
        layout: '',
        label: 'Title',
        required: false,
      },
      {
        type: 'tel',
        id: 'phone_number',
        layout: '',
        label: 'Phone',
        required: false,
      },
      {
        type: 'tel',
        id: 'fax_number',
        layout: '',
        label: 'Fax',
        required: false,
      },
      {
        type: 'tel',
        id: 'mobile_number',
        layout: '',
        label: 'Mobile',
        required: false,
      },
      {
        type: 'email',
        id: 'email',
        layout: '',
        label: 'Email',
        required: 'Required',
      },
      {
        id: 'clients',
        label: 'Clients',
        type: 'autocomplete',
        layout: '',
        multiple: true,
        required: false,
        autoCompleteProps: {
          checkInputValue: false,
          valueIdAttr: 'id',
          valueLabelAttr: 'business_name',
          fetchRecord: businessService.getBusiness,
          fetchSuggestions: (searchText) => fetchFactoringBusinessSuggestions(searchText),
          defaultSuggestion: `Start typing to find a client.`,
          addButton: false,
        },
      },
      {
        type: 'textarea',
        id: 'note',
        layout: '',
        label: 'Note',
        required: false,
      },
    ],
  }
  syncronousClient = clientData

  return (
    <S_AddContactModal>
      <h2>{clientId ? `View/Update Contact` : `Create new contact for debtor`}</h2>

      <ValidationForm
        entity={config.entity}
        fields={config.fields}
        getFormFunctions={({ submitForm }) => {
          setSubmitFn(submitForm)
        }}
        isDisabled={readOnly}
        onBlur={(id, setError, value) => {
          if (id === 'clients') {
            let clientsIdArray = value.items.map((client) => client.id)
            let newState = { ...clientData }
            newState[id] = clientsIdArray
            setClientData(newState)
          }
        }}
        onChange={(id, newValue) => {
          let newState = { ...clientData }
          newState[id] = newValue.target ? newValue.target.value : newValue
          setClientData(newState)
        }}
        submitHandler={async () => {
          setIsDisabled(true)

          if (clientId) {
            await updateContact(debtor.id, clientId, { ...syncronousClient })
            showNotification({ id: 'create-contact-noty', type: 'success', message: 'Contact Updated' })
          } else {
            await createContact(debtor.id, { ...syncronousClient })
            showNotification({ id: 'create-contact-noty', type: 'success', message: 'Contact Created' })
          }
          if (callFromModal) {
            const { Modal, ...restModalProps } = previousModalProps
            openModal(Modal, {
              Modal: Modal,
              ...restModalProps,
            })
          } else {
            refresh()
            closeModal()
          }
        }}
      />

      <S_Submit className="submit" hidden={readOnly || isDisabled}>
        <LoaderButton onClick={submitFn} text="Save" />
      </S_Submit>
    </S_AddContactModal>
  )
}
